import { IntakeSymptomDetailQuestionType } from "~/common/utils/consultations/intake";
import { RadioGroupOptions } from "~/common/utils/consultations/shared";

export const extractRadioGroupValues = (
  options: readonly RadioGroupOptions[],
) =>
  options.flatMap((option) => option.group) as [
    IntakeSymptomDetailQuestionType,
  ];
